export const mapAccessControlToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
    numOfSubRoute: item?.children?.length,
    numOfPermission: item?.permissions?.length,
  }));

  return result;
};

export const accessControlColumns = [
  { key: "name", label: "Name", align: "center" },
  { key: "route", label: "Email", align: "center" },
  { key: "numOfSubRoute", label: "Number Sub Route", align: "center" },
  { key: "numOfPermission", label: "Number Of Permission", align: "center" },
];
